"use client";
import * as React from "react";
import { Testimonial } from "./testimonial";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { ExtractBySectionType } from "types";
import { SectionType } from "types";

type TestimonialsType = ExtractBySectionType<
  SectionType,
  "testimonials",
  "_type"
>;

export function Testimonials({ data, classNames }: { data: TestimonialsType, classNames?: string }) {
  const { testimonialItems } = data;
  return (
    <section className={`bg-[url('/index/testimonials/vector.svg')] bg-no-repeat bg-[center_left_57%] bg-contain my-20 ${classNames || 'bg-white'}`}>
      <div className="max-w-screen-2xl mx-auto">
        {testimonialItems && (
          <Carousel
            className="p-6 lg:p-10 flex flex-col"
            opts={{ align: "start", loop: true }}
          >
            <CarouselNext className="hidden md:flex absolute right-4" />
            <CarouselPrevious className="absolute left-4 hidden md:flex" />

            <div className="flex gap-4 absolute left-20 bottom-4 md:hidden">
              <CarouselPrevious />
              <CarouselNext />
            </div>
            <CarouselContent className="">
              {testimonialItems.map((testimonial, index) => {
                return (
                  <CarouselItem
                    key={index}
                    className="mx-auto flex items-center justify-center"
                  >
                    <div className="py-20 lg:px-8">
                      <Testimonial
                        quote={testimonial.quote}
                        name={testimonial.author}
                        role={testimonial.authorRole}
                        image={testimonial.authorImage}
                        blurHash={
                          testimonial.authorImage.asset?.metadata?.lqip || ""
                        }
                      />
                    </div>
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>
        )}
      </div>
    </section>
  );
}
